export default __webpack_public_path__ + "static/media/element_23.82306196.avif";